export interface Bonus {
  number: number
  title: string
  description: string
  image: string
  alt: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'The 5-Minute Ballet Class Planner',
    description:
      'Ready-to-use class plans that get a full session on paper in minutes.',
    image:
      'https://cdn.magicpatterns.com/uploads/kkbpMi9fayxUbRmpqXU5yQ/ChatGPT_Image_6_sept_2026,_02_03_57.webp',
    alt: 'Bonus 1 cover: The 5-Minute Ballet Class Planner',
  },
  {
    number: 2,
    title: 'The Mixed-Level Ballet Class Adaptation Kit',
    description:
      'Modifications and strategies to teach every level together, without chaos.',
    image:
      'https://cdn.magicpatterns.com/uploads/uPYhDbKMgZbvcjqGXpF32X/ChatGPT_Image_6_sept_2026,_02_05_00.webp',
    alt: 'Bonus 2 cover: The Mixed-Level Ballet Class Adaptation Kit',
  },
  {
    number: 3,
    title: 'Age-by-Age Ballet Teaching Map',
    description:
      'A clear roadmap of what to teach at every stage, from ages 3 to 16.',
    image:
      'https://cdn.magicpatterns.com/uploads/dBnhDYhotqGMBtBpmtBNyZ/ChatGPT_Image_6_sept_2026,_02_05_48.webp',
    alt: 'Bonus 3 cover: Age-by-Age Ballet Teaching Map',
  },
  {
    number: 4,
    title: 'Ballet Music & Counts Cheat Sheet',
    description:
      'The right tempo, rhythm and counts for every exercise in the class.',
    image:
      'https://cdn.magicpatterns.com/uploads/ed4DdBDwi3jugP2KGgUkxn/ChatGPT_Image_6_sept_2026,_02_06_57.webp',
    alt: 'Bonus 4 cover: Ballet Music & Counts Cheat Sheet',
  },
  {
    number: 5,
    title: 'Emergency Class Pack',
    description:
      'Complete classes ready to print for substitutes and last-minute days.',
    image:
      'https://cdn.magicpatterns.com/uploads/rCwot7LinLHagUXsux3Tcx/ChatGPT_Image_6_sept_2026,_02_08_42.webp',
    alt: 'Bonus 5 cover: Emergency Class Pack',
  },
  {
    number: 6,
    title: '30 Themed Classes for Kids',
    description:
      'Thirty creative lesson plans that keep young dancers in love with ballet.',
    image:
      'https://cdn.magicpatterns.com/uploads/1qo3Lpkf8vpxjqExQfcS96/ChatGPT_Image_6_sept_2026,_02_10_40.webp',
    alt: 'Bonus 6 cover: 30 Themed Classes for Kids',
  },
  {
    number: 7,
    title: 'Quick-Start Printables Vault',
    description:
      'Planners, checklists, trackers and certificates, editable and ready to print.',
    image:
      'https://cdn.magicpatterns.com/uploads/8E9h5bozh2r3E81SunWrrq/ChatGPT_Image_6_sept_2026,_02_11_58.webp',
    alt: 'Bonus 7 cover: Quick-Start Printables Vault',
  },
]
